import { createBrowserRouter, Navigate } from 'react-router-dom';
import { Shell } from '@/components/layout/Shell';
import { LoginPage } from '@/pages/LoginPage';
import { DashboardPage } from '@/pages/DashboardPage';
import { AgentsPage } from '@/pages/AgentsPage';
import { AgentPersonnelPage } from '@/pages/AgentPersonnelPage';
import { OrganizationPage } from '@/pages/OrganizationPage';
import { SessionsPage } from '@/pages/SessionsPage';
import { ActivityPage } from '@/pages/ActivityPage';
import { SkillsPage } from '@/pages/SkillsPage';
import { RulesPage } from '@/pages/RulesPage';
import { ProposalsPage } from '@/pages/ProposalsPage';
import { SchedulerPage } from '@/pages/SchedulerPage';
import { SystemPage } from '@/pages/SystemPage';
import { UsersPage } from '@/pages/UsersPage';
import { ProfilePage } from '@/pages/ProfilePage';
import { SettingsPage } from '@/pages/SettingsPage';
import { UsagePage } from '@/pages/UsagePage';

export const router = createBrowserRouter([
  { path: '/login', element: <LoginPage /> },
  {
    element: <Shell />,
    children: [
      { index: true, element: <Navigate to="/dashboard" replace /> },
      { path: '/dashboard', element: <DashboardPage /> },
      { path: '/agents', element: <AgentsPage /> },
      { path: '/agents/:name', element: <AgentPersonnelPage /> },
      { path: '/organization', element: <OrganizationPage /> },
      { path: '/sessions', element: <SessionsPage /> },
      { path: '/sessions/:id', element: <SessionsPage /> },
      { path: '/activity', element: <ActivityPage /> },
      { path: '/skills', element: <SkillsPage /> },
      { path: '/rules', element: <RulesPage /> },
      { path: '/proposals', element: <ProposalsPage /> },
      { path: '/scheduler', element: <SchedulerPage /> },
      { path: '/usage', element: <UsagePage /> },
      { path: '/system', element: <SystemPage /> },
      { path: '/users', element: <UsersPage /> },
      { path: '/profile', element: <ProfilePage /> },
      { path: '/settings', element: <SettingsPage /> },
    ],
  },
  { path: '*', element: <Navigate to="/dashboard" replace /> },
]);
